import instance from 'api';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IObjectType } from './interfaces';

export const getObjectTypeList = (data: IDynamicTableParams) => {
  return instance()
    .post('/realEstateObjectType/list', data)
    .then((response) => response.data);
};

export const getObjectTypeAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/realEstateObjectType/availableColumns', {})
    .then((response) => response.data);
};

export const getObjectTypeAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/realEstateObjectType/availableGroupColumns')
    .then((response) => response.data);
};

export const loadObjectType = (id: number) => {
  return instance()
    .get<IObjectType>(`/realEstateObjectType/load/${id}`)
    .then((response) => response.data);
};

export const saveObjectType = (data: { name: string }) => {
  return instance()
    .post('/realEstateObjectType/save', data)
    .then((response) => response.data);
};

export const updateObjectType = (id: number, data: { name: string }) => {
  return instance()
    .post(`/realEstateObjectType/${id}/update`, data)
    .then((response) => response.data);
};

export const archiveObjectType = (realEstateObjectTypeId: number) => {
  return instance()
    .post('/realEstateObjectType/archive', { realEstateObjectTypeId })
    .then((response) => response.data);
};

export const recoverObjectType = (realEstateObjectTypeId: number) => {
  return instance()
    .post('/realEstateObjectType/recover', { realEstateObjectTypeId })
    .then((response) => response.data);
};
